import React, { Dispatch, SetStateAction } from "react"
import { useAppDispatch } from "lib/store"
import { showEditSidebar } from "lib/store/services/editSidebar/slice"
import { User } from "@lib/types/generated/graphql-types"
import dayjs from "dayjs"

import {
  Wrapper,
  Container,
  StyledTableHeader,
  Username,
  Name,
  Email,
  Date,
  StyledTableRow
} from "./UserTable.styled"

import { BrinkLoader } from "components/Ui/BrinkLoader"
import ErrorMessage from "components/Ui/Messages/ErrorMessage"
import Status from "components/Ui/Status"

import { ReactComponent as UserIcon } from "images/icons/user-large.svg"

type Props = {
  users: User[]
  loading?: boolean
  error: object | undefined
  editId: string
  setEditId: Dispatch<SetStateAction<string>>
}

export const UserTable = ({ users, loading = false, error, setEditId }: Props) => {
  const dispatch = useAppDispatch()

  return (
    <Wrapper>
      <Container>
        {error && (
          <ErrorMessage
            showRefreshButton
            message={
              <>
                Error loading Users. Try refreshing the page, or contact{" "}
                <a href="mailto:support@brinkcommerce.com">support</a>.
              </>
            }
          />
        )}

        {loading && <BrinkLoader />}
        <StyledTableHeader>
          <Username>User</Username>
          <div>Status</div>
          <div>Confirmation status</div>
          <Date>Created</Date>
          <Date>Updated</Date>
        </StyledTableHeader>
        {[...users].map((user) => (
          <StyledTableRow
            key={user.username}
            handleOnClick={() => {
              setEditId(user.username)
              dispatch(showEditSidebar())
            }}
          >
            <UserIcon />
            <Username>
              <div>
                <Name>
                  {user.givenName} {user.familyName}
                </Name>
                <Email>{user.username}</Email>
              </div>
            </Username>
            <div>
              <Status status={user.enabled ? "ENABLED" : "DISABLED"} />
            </div>
            <div>
              <Status status={user.status === "CONFIRMED" ? "CONFIRMED" : "NOT CONFIRMED"} />
            </div>
            <Date>{dayjs(user.created).format("YYYY-MM-DD")}</Date>
            <Date>{dayjs(user.updated).format("YYYY-MM-DD")}</Date>
          </StyledTableRow>
        ))}
      </Container>
    </Wrapper>
  )
}
